import { UserManager } from "oidc-client";
import { ClientInfo, IdentityServerConfig, IdSvrPreAuthOptions } from "./models";

export class IdServerPreAuth {
    private options: IdSvrPreAuthOptions = {
        clientInfoApiUrl: IdentityServerConfig.ClientInfoApiUrl,
        accessTokenSessionKey: IdentityServerConfig.AccessTokenKey
    };

    public constructor(options?: Partial<IdSvrPreAuthOptions>) {
        if (options !== null) {
            this.options = Object.assign(this.options, options);
        }
    }

    public signIn(): void {
        this.fetchClientInfo().then(ci => this.internalSignIn(ci));
    }

    private fetchClientInfo(): Promise<ClientInfo> {
        return new Promise<ClientInfo>((resolve, reject) => {
            fetch(this.options.clientInfoApiUrl)
                .then(response => {
                    return response.json();
                })
                .then(
                    response => {
                        sessionStorage.setItem(IdentityServerConfig.ClientInfoKey, JSON.stringify(response));
                        resolve(response);
                    },
                    _ => reject()
                );
        });
    }
    private clearIdToken(): void {
        if (history) {
            if (window.location.hash.indexOf("#id_token=") > -1) {
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }
    }

    private internalSignIn(clientInfo: ClientInfo): void {
        const manager = new UserManager({
            response_type: "id_token token",
            scope: "openid " + clientInfo.clientId,
            silent_redirect_uri: window.location.protocol + "//" + window.location.host + "/silent_renew.html",
            automaticSilentRenew: false,
            monitorSession: false,
            filterProtocolClaims: true,
            loadUserInfo: false,
            accessTokenExpiringNotificationTime: 100,
            revokeAccessTokenOnSignout: false,
            silentRequestTimeout: 10000,
            client_id: clientInfo.clientId,
            redirect_uri: clientInfo.clientUrl,
            authority: clientInfo.authorityUrl
        });

        if (window.location.href.indexOf("#id_token=") > -1) {
            manager.signinRedirectCallback().then(function (user) {
                if (user.state) {
                    window.location.href = user.state;
                }
            });
        }

        manager.signinSilent().then(
            (result: any) => {
                sessionStorage.setItem(this.options.accessTokenSessionKey, result.access_token);
                this.clearIdToken();
                if (this.options.onSuccessCallback) {
                    this.options.onSuccessCallback();
                }
            },
            () => {
                manager.signinRedirect({ data: window.location.href });
            }
        );
    }
}
